const HeardIt = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="90%" viewBox="0 0 74 54" fill="none">
            <path d="M69 5L25 49L5 29" stroke="#FEFEFE" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}
export default HeardIt